"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-validator';
var ValidatorContext;
(function (ValidatorContext) {
    ValidatorContext["Danger"] = "danger";
    ValidatorContext["Warning"] = "warning";
})(ValidatorContext = exports.ValidatorContext || (exports.ValidatorContext = {}));
var Validator = (function (_a) {
    var className = _a.className, context = _a.context, contextLabel = _a.contextLabel, message = _a.message, messageId = _a.messageId, children = _a.children, restProps = __rest(_a, ["className", "context", "contextLabel", "message", "messageId", "children"]);
    var _b, _c;
    return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, (_b = {}, _b[CLASS_NAME + "--" + context] = !!context, _b), className) }, restProps),
        children,
        context && message && (React.createElement("div", { id: messageId, className: classNames(CLASS_NAME + "__message", (_c = {},
                _c["text-" + context] = !!context,
                _c)) }, contextLabel ? contextLabel + ": " + message : message))));
});
exports.Validator = Validator;
Validator.Context = ValidatorContext;
//# sourceMappingURL=Validator.js.map